export default "__VITE_ASSET__QrWLh$iS__"